var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 223,
    viewBox: "0 0 224 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69.7299,
    cy: 69.7299,
    r: 69.7299,
    transform: "matrix(-1 7.00515e-09 7.00515e-09 1 183.115 48.7236)",
    fill: "#3B57E9",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.37054,
    cy: 4.37054,
    r: 4.37054,
    transform: "matrix(-1 7.00515e-09 7.00515e-09 1 183.115 67.001)",
    fill: "#F1F3FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.14509,
    cy: 8.14509,
    r: 8.14509,
    transform: "matrix(-1 7.00515e-09 7.00515e-09 1 71.8652 34.8174)",
    fill: "#F1F3FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.74777,
    cy: 7.74777,
    r: 7.74777,
    transform: "matrix(-1 7.00515e-09 7.00515e-09 1 191.496 149.25)",
    fill: "#F1F3FF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.74777,
    cy: 7.74777,
    r: 7.74777,
    transform: "matrix(-1 7.00515e-09 7.00515e-09 1 46.4375 148.054)",
    fill: "#F1F3FF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.77455,
    cy: 3.77455,
    r: 3.77455,
    transform: "matrix(-1 7.00515e-09 7.00515e-09 1 57.5625 160.769)",
    fill: "#F1F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0488 131.895L33.8321 137.643L28.166 138.877L33.8321 140.111L35.0488 145.86L36.2656 140.111L41.9316 138.877L36.2656 137.643L35.0488 131.895Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3262 73.2075C42.2373 72.7874 41.6377 72.7874 41.5488 73.2075L40.774 76.868C40.7416 77.021 40.6226 77.1407 40.4698 77.174L36.8367 77.9654C36.4197 78.0563 36.4197 78.651 36.8367 78.7419L40.4698 79.5333C40.6226 79.5666 40.7416 79.6863 40.774 79.8393L41.5488 83.4998C41.6377 83.9199 42.2373 83.9199 42.3262 83.4998L43.101 79.8393C43.1334 79.6863 43.2524 79.5666 43.4052 79.5333L47.0383 78.7419C47.4553 78.651 47.4553 78.0563 47.0383 77.9654L43.4052 77.174C43.2524 77.1407 43.1334 77.021 43.101 76.868L42.3262 73.2075Z",
    fill: "#C4CBF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.602 121.283C186.513 120.863 185.914 120.863 185.825 121.283L184.497 127.557C184.464 127.71 184.345 127.83 184.193 127.863L177.983 129.216C177.566 129.307 177.566 129.902 177.983 129.993L184.193 131.345C184.345 131.379 184.464 131.498 184.497 131.651L185.825 137.926C185.914 138.346 186.513 138.346 186.602 137.926L187.93 131.651C187.963 131.498 188.082 131.379 188.235 131.345L194.445 129.993C194.862 129.902 194.862 129.307 194.445 129.216L188.235 127.863C188.082 127.83 187.963 127.71 187.93 127.557L186.602 121.283Z",
    fill: "#C4CBF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M161.848 54.4995C162.079 54.4505 162.079 54.1218 161.848 54.0728L158.365 53.3321C158.281 53.3143 158.216 53.2489 158.198 53.165L157.448 49.7068C157.398 49.4775 157.071 49.4775 157.021 49.7068L156.271 53.165C156.253 53.2489 156.188 53.3143 156.104 53.3321L152.621 54.0728C152.391 54.1218 152.39 54.4505 152.621 54.4995L156.104 55.2401C156.188 55.258 156.253 55.3234 156.271 55.4073L157.021 58.8655C157.071 59.0947 157.398 59.0947 157.448 58.8655L158.198 55.4073C158.216 55.3234 158.281 55.258 158.365 55.2401L161.848 54.4995Z",
    fill: "#C4CBF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M153.116 148.298L152.836 148.648L153.153 148.964L184.022 179.833L176.833 187.022L145.964 156.153L145.648 155.836L145.298 156.116C136.786 162.926 125.991 167 114.25 167C86.7881 167 64.5 144.712 64.5 117.25C64.5 89.7881 86.7881 67.5 114.25 67.5C141.712 67.5 164 89.7881 164 117.25C164 128.991 159.926 139.786 153.116 148.298ZM142.658 144.821L142.663 144.816C149.578 137.69 153.833 127.969 153.833 117.25C153.833 95.3803 136.12 77.6667 114.25 77.6667C92.3803 77.6667 74.6667 95.3803 74.6667 117.25C74.6667 139.12 92.3803 156.833 114.25 156.833C124.969 156.833 134.69 152.578 141.816 145.663L141.821 145.658L142.658 144.821Z",
    fill: "#CFD6FF",
    stroke: "#B6C1FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M115.001 115.762L124.638 106.125L126.877 108.364L117.24 118.001L126.875 127.636L124.636 129.875L115.001 120.24L105.364 129.877L103.125 127.638L112.762 118.001L103.125 108.364L105.364 106.125L115.001 115.762Z",
    fill: "#CFD6FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.b7a2b4d6c671a65d6b07066beb5451b3.svg";
export { ForwardRef as ReactComponent };